import { useClubLogo } from '../lib/useClubLogo';
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Shield, Lock, ArrowLeft } from 'lucide-react';
import { adminApi } from '../lib/api';
import { toast } from 'sonner';



export default function AdminLoginPage() {
  const LOGO_URL = useClubLogo();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await adminApi.login(password);
      localStorage.setItem('admin_token', res.data.token);
      toast.success('Erfolgreich eingeloggt');
      navigate('/admin/dashboard');
    } catch (err) {
      const msg = err.response?.data?.detail || 'Login fehlgeschlagen';
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[hsl(0,0%,5%)] flex">
      <div className="hidden md:flex md:w-1/2 items-center justify-center p-12 relative overflow-hidden">
        <div className="absolute inset-0" style={{ background: 'radial-gradient(800px 400px at 30% 40%, rgba(204,0,0,0.08) 0%, transparent 60%)' }} />
        <div className="relative text-center">
          <div className="w-32 h-32 mx-auto mb-6 rounded-full overflow-hidden bg-[hsl(0,0%,12%)] p-1">
            <img src={LOGO_URL} alt="Logo" className="w-full h-full object-contain rounded-full logo-glow" style={{ background: '#141414' }} />
          </div>
          <h1 className="text-4xl font-bold text-white mb-3" style={{ fontFamily: 'Space Grotesk' }}>DRESDEN DEVILS</h1>
          <p className="text-white/40 text-sm">Admin-Verwaltung</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/40 hover:text-white/60 mb-8 transition-colors duration-200">
            <ArrowLeft className="w-4 h-4" /> Zurück zur Website
          </Link>

          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-xl bg-[#CC0000]/10 flex items-center justify-center">
              <Shield className="w-6 h-6 text-[#CC0000]" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Space Grotesk' }}>Admin-Bereich</h2>
              <p className="text-xs text-white/40">Passwortgeschützt</p>
            </div>
          </div>

          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label className="block text-sm text-white/60 mb-2">Passwort</label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" />
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                  placeholder="Admin-Passwort eingeben"
                  className="w-full pl-10 pr-4 py-3 bg-[hsl(0,0%,8%)] border border-white/10 rounded-lg text-white text-sm placeholder:text-white/30 focus:outline-none focus:ring-2 focus:ring-[#46C7FF] focus:border-transparent transition-shadow duration-200"
                  data-testid="admin-login-password-input" autoFocus />
              </div>
            </div>
            {error && <p className="text-sm text-red-400 mb-4" data-testid="admin-login-error-text">{error}</p>}
            <button type="submit" disabled={loading || !password}
              className="w-full py-3 bg-[#CC0000] text-white font-semibold rounded-lg hover:bg-[#B30000] disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.98] transition-colors duration-200 text-sm"
              data-testid="admin-login-submit-button">
              {loading ? 'Wird angemeldet...' : 'Anmelden'}
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}
